/**
 * Listen for `avatar-changed` socket events for a specific user.
 *
 * The company-room subscription is already established by `useCompanyPresenceSocket`
 * (mounted in the OnlineUsersPanel inside Dashboard) — so we only attach an extra
 * listener here. Doesn't manage subscribe/unsubscribe of its own.
 */
import { useEffect } from "react";
import { socket } from "services/socket-client";

interface AvatarChangedPayload {
  userId: string;
  avatarFileId: string | null;
}

export function useAvatarChangedListener(
  targetUserId: string | undefined,
  onChange: (avatarFileId: string | null) => void
) {
  useEffect(() => {
    if (!targetUserId) return;
    const handler = (...args: unknown[]) => {
      const payload = args[0] as AvatarChangedPayload | undefined;
      if (payload && payload.userId === targetUserId) {
        onChange(payload.avatarFileId);
      }
    };
    socket.on("avatar-changed", handler);
    return () => socket.off("avatar-changed", handler);
  }, [targetUserId, onChange]);
}
